export default __webpack_public_path__ + "static/media/Faturas (Real Size).49632d92.svg";